export const accessories: Array<string> = [
  require("./Ass_1.svg").default,
  require("./Ass_2.svg").default,
  require("./Ass_3.svg").default,
  require("./Ass_4.svg").default,
  require("./Ass_5.svg").default,
  "",
];
